import store from '../redux';
import { parseUrlContext } from '../routing/contextUrl';

/**
 * Resolve the instance the current tab is working on.
 *
 * URL `/i/:slug` is the source of truth for multi-tab isolation. Falls back to
 * the authenticated user's primary instance when the URL has no prefix.
 *
 * @returns {{ slug: string|null, id: string|null }}
 */
export function getRequestInstanceRef() {
    const urlCtx = parseUrlContext();
    if (urlCtx.slug) {
        const state = store.getState();
        const instances = state?.tktInstances?.tktInstances;
        let id = null;
        if (Array.isArray(instances)) {
            const match = instances.find((i) => i?.slug === urlCtx.slug);
            if (match?.id != null) {
                id = String(match.id);
            }
        }
        if (!id) {
            const userInstance = state?.auth?.user?.tkt_instance;
            if (userInstance?.slug === urlCtx.slug && userInstance?.id != null) {
                id = String(userInstance.id);
            }
        }
        return { slug: urlCtx.slug, id };
    }

    const user = store.getState()?.auth?.user;
    const ti = user?.tkt_instance;
    return {
        slug: ti?.slug || null,
        id: ti?.id != null ? String(ti.id) : (user?.tkt_instance_id != null ? String(user.tkt_instance_id) : null),
    };
}

/**
 * Headers telling Kore which instance this tab expects.
 * Skipped for profile so the response keeps the persisted primary instance.
 *
 * @param {string} [route_path]
 * @returns {Record<string, string>}
 */
export function buildRequestInstanceHeaders(route_path = '') {
    if (typeof route_path === 'string' && route_path.startsWith('/kuser/profile')) {
        return {};
    }

    const { slug, id } = getRequestInstanceRef();
    const headers = {};
    if (id) {
        headers['X-Tkt-Instance-Id'] = id;
    }
    if (slug) {
        headers['X-Tkt-Instance-Slug'] = slug;
    }
    return headers;
}

/**
 * Query param for browser navigations that cannot send custom headers (exports, ICS).
 *
 * @returns {string|null}
 */
export function getRequestInstanceQueryValue() {
    const { slug, id } = getRequestInstanceRef();
    return id || slug || null;
}
